<template>
    <d-container fluid class="main-content-container px-4 pb-4">
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
                <h3 class="page-title">Reactivate your subscription</h3>
            </d-col>
        </d-row>
        <d-row>
            <d-col lg="12" class="mb-4">
                <d-card class="card-small" v-if="checkPermission(permissionTypes.billingWrite)">
                    <d-card-body>
                        <p>To reactivate your subscription and recover your payment plan, please click the button below.</p>
                        <button class="btn btn-success btn-sm" @click="reactivate">Reactivate subscription</button>
                    </d-card-body>
                </d-card>
                <no-permission-message v-else />
            </d-col>
        </d-row>
    </d-container>
</template>

<script>
import notification from '@/mixins/notification';
import permissions from '../../mixins/permissions';
import {BillingService} from "@/main";

export default {
    mixins: [notification, permissions],

    data() {
        return {
            percent: 25,
        };
    },

    computed: {
        userInfo() {
            return this.$store.getters.userInfo
        },
    },

    methods: {
        async reactivate() {
            try {
                const paymentUrl = await BillingService.reactivate()
                if (paymentUrl) {
                    window.location.replace(paymentUrl)
                } else {
                    this.showNotification('warn', 'We have a problem', 'Please contact with support')
                }
            } catch {
                this.showNotification('warn', 'We have a problem', 'Please contact with support')
            }
        }
    },
};
</script>
